const Module = () => import('./HcetModule.vue');

const setBreadcrumbs = (to, from) => {
    let breadcrumbs = [];

    if (from.name == 'hcetransactions' && (to.name == 'newtransaction' || to.name == 'edittransaction')) {
        breadcrumbs.push({ label: 'Health Care Entity Transactions', route: '/hce/transactions' });
        breadcrumbs.push({ label: to.meta.title });
    }
    else if (from.name == 'programHces' && (to.name == 'newtransaction' || to.name == 'edittransaction')) {
        breadcrumbs.push({ label: 'Review HCE Transactions', route: '/program/programHces' });
        breadcrumbs.push({ label: to.meta.title });
    }
     else {
        breadcrumbs = to.meta.breadcrumb;
    }

    return breadcrumbs;
};

const filterPath = (to, from, next) => {
    if (to.fullPath !== to.path) {
      to.meta.breadcrumb = setBreadcrumbs(to, from);
      next({ path: to.path });
    } else {
      to.meta.breadcrumb = setBreadcrumbs(to, from);
      next();
    }
  };

const moduleRoutes = {
    path: '/hce',
    component: Module,
    children: [
        {
            path: 'transaction/:id',
            name: 'edittransaction',
            props: true,
            meta: {
                title: 'Health Care Entity Transaction',
                requiresAuth: true,
                breadcrumb: [
                    { label: 'Health Care Entity Transactions', route: '/hce/transactions' },
                    { label: 'Health Care Entity Transaction' }
                ]
            },
            component: () => import('./views/HceTransactionView.vue'),
            beforeEnter: filterPath
        },
        {
            path: 'transactions',
            name: 'hcetransactions',
            meta: {
                title: 'Health Care Entity Transactions',
                requiresAuth: true,
                breadcrumb: [
                    { label: 'Health Care Entity Transactions' }
                ]
            },
            component: () => import('./views/HceTransactionListingView.vue'),
            beforeEnter: filterPath
        },
    ]
};

export default router => {
    router.addRoute(moduleRoutes);
};